import React, { useMemo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { ApolloProvider } from '@apollo/react-hooks';
import { useAuth0 } from '@auth0/auth0-react';
import { createAuth0ApolloClient, clearApolloClient } from './auth0-client';

const Auth0ApolloProvider = ({ children }) => {
  const { getIdTokenClaims, isAuthenticated, isLoading, error } = useAuth0();

  const client = useMemo(() => {
    // For unauthenticated users, create a client that won't attempt token exchange
    if (!isAuthenticated || isLoading) {
      return createAuth0ApolloClient(() => Promise.resolve({}));
    }

    // For authenticated users, create a client with token exchange
    if (getIdTokenClaims) {
      return createAuth0ApolloClient(getIdTokenClaims);
    }

    // Fallback for authenticated users without getIdTokenClaims
    return createAuth0ApolloClient(() => Promise.resolve({}));
  }, [isAuthenticated, isLoading, getIdTokenClaims]);

  // Handle authentication errors
  useEffect(() => {
    if (error) {
      console.error('Authentication error:', error);
    }
  }, [error]);

  // Clear client when user logs out
  useEffect(() => {
    if (!isAuthenticated && !isLoading) {
      clearApolloClient();
    }
  }, [isAuthenticated, isLoading]);

  return <ApolloProvider client={client}>{children}</ApolloProvider>;
};

Auth0ApolloProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Auth0ApolloProvider;
